"use client";
import { useRouter } from "next/navigation";
import { useIsMobileView } from "@/hooks/useIsMobileView";
import { useEffect } from "react";
import { routes } from "@/constants";

export const useIsMobileRedirect = () => {
  const router = useRouter();
  const isMobile = useIsMobileView();

  useEffect(() => {
    if (isMobile) {
      router.push(routes.inPersonMobile.index);
    }
  }, [isMobile, router]);

  return isMobile;
};
